// Attach click handlers for Read More buttons in the ingredients list
// Publishes '<modal-id>:open' with the article URL + section_id

(function () {
  const MODAL_ID = "ingredients-modal";
  const SECTION_HANDLE = "sb-ingredient-modal-content";

  /**
   * @param {string} articleUrl
   * @returns {string}
   */
  function buildSectionUrl(articleUrl) {
    // Build a locale-aware absolute base URL per Shopify's docs
    // https://shopify.dev/docs/api/ajax/section-rendering
    try {
      const root = /** @type {any} */ (window.Shopify)?.routes?.root || "/";
      const origin = window.location.origin;
      const base = origin + (root.startsWith("/") ? root : `/${root}`);
      const url = new URL(articleUrl, base);
      url.searchParams.set("section_id", SECTION_HANDLE);
      return url.toString();
    } catch (e) {
      const url = new URL(articleUrl, window.location.origin);
      url.searchParams.set("section_id", SECTION_HANDLE);
      return url.toString();
    }
  }

  /**
   * @param {MouseEvent} event
   */
  function handleClick(event) {
    const btn = event.currentTarget;
    if (!(btn instanceof HTMLElement)) return;
    const articleUrl = btn.getAttribute("data-article-url");
    if (!articleUrl) return;
    // Save trigger to restore focus on close
    /** @type {HTMLElement & { lastTrigger?: HTMLElement, open?: () => void, currentSectionUrl?: string } | null} */
    const modal = document.querySelector(
      `sb-ingredients-modal[data-modal-id="${MODAL_ID}"]`
    );
    if (modal) modal.lastTrigger = btn;
    const sectionUrl = buildSectionUrl(articleUrl);
    if (typeof window.TD_PUBLISH === "function") {
      window.TD_PUBLISH(`${MODAL_ID}:open`, { sectionUrl });
    } else if (modal && typeof modal.open === "function") {
      // Fallback: open directly if pub/sub is not yet available
      modal.currentSectionUrl = sectionUrl;
      modal.open();
    }
  }

  /**
   * @param {Document|Element} [container=document]
   */
  function wire(container = document) {
    container.querySelectorAll("[data-ingredient-read-more]")?.forEach((el) => {
      el.removeEventListener("click", handleClick);
      el.addEventListener("click", handleClick);
    });
  }

  // Optional: if this section is dynamically re-rendered via the Section Rendering API,
  // listen for a custom event to re-bind handlers (pattern similar to other components)
  document.addEventListener("ingredients:list:updated", (e) => {
    const detail = /** @type {CustomEvent} */ (e).detail || {};
    const target =
      detail.container instanceof Element ? detail.container : document;
    wire(target);
  });

  document.addEventListener("DOMContentLoaded", () => wire());
  document.addEventListener("shopify:section:load", (e) =>
    wire(e.target instanceof Element ? e.target : document)
  );
})();
